import Vue from 'vue';
import { StartLoad } from '../store/actions';


const Util = {
  install: (VueInstance: any, options: any) => {
    VueInstance.prototype.$getIcon = (iconName: string) => {
      return iconName ? require('../assets/icons/' + iconName) : '';
    };

    VueInstance.prototype.$getRandomId = () => {
      const s4 = () => {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      };
      return 'ID' + s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4();
    };
    
    VueInstance.prototype.$_getSvg = (iconName: string) => {
      return require('../assets/icons/' + iconName);

    };
    
    VueInstance.prototype.$routerUpdateQuery = (vue: Vue, obj: any) => {
      const o = vue.$route.query;
      const query: any = {};
      // read url
      for (const k in o) {
        if (o[k]) {
          query[k] = o[k];
        }
      }
      // update
      for (const p in obj) {
        if (obj[p] || obj[p] === 0) {
          query[p] = obj[p];
          if (query[p] === 'delete') {
            delete query[p];
          }
        }
      }
      vue.$router.push({
        query: query
      });
    };
  },
  checkStartLoad: (args: {
    loadingCount: number,
    startLoad: StartLoad,
    retryCondition: () => boolean,
    allDoneCallback: () => void
  }) => {
    const loadingCountMax = 60;
    if (args.loadingCount > loadingCountMax) { // after * sec always failed
      console.log('network error');
      return;
    }
    // wait 500 ms until threads inited
    if (args.retryCondition() && args.loadingCount <= loadingCountMax) {
      setTimeout(Util.checkStartLoad.bind(null, args), 500);
      args.loadingCount++;
      return;
    }
    let allDone = true;
    for (const subscriber of args.startLoad.threads) {
      if (!subscriber.closed) {
        allDone = false;
        setTimeout(Util.checkStartLoad.bind(null, args), 500);
        break;
      }
    }
    if (allDone) {
      args.allDoneCallback();
    }

  }
};

export default Util;
